var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconRand18 = function SvgAIconRand18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5V4.5C5 4.22386 5.22386 4 5.5 4H10.25C11.7688 4 13 5.23122 13 6.75C13 8.26878 11.7688 9.5 10.25 9.5H10M5 9.5V14M5 9.5H10M10 9.5L13 14",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
};
export { SvgAIconRand18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik01IDkuNVY0LjVDNSA0LjIyMzg2IDUuMjIzODYgNCA1LjUgNEgxMC4yNUMxMS43Njg4IDQgMTMgNS4yMzEyMiAxMyA2Ljc1QzEzIDguMjY4NzggMTEuNzY4OCA5LjUgMTAuMjUgOS41SDEwTTUgOS41VjE0TTUgOS41SDEwTTEwIDkuNUwxMyAxNCIgc3Ryb2tlLXdpZHRoPSIxLjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPC9zdmc+";